import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { LocationEvaluationService } from '../services/http/location-evaluation.service';

@Injectable()
export class LocationEvaluationInterceptor implements HttpInterceptor {

  constructor(private readonly locationEvaluationService : LocationEvaluationService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.locationEvaluationService.running();
    return next.handle(request).pipe(finalize( () => {
      this.locationEvaluationService.notRunning()
    }));
  }
}
